import {
  canAccessCampaignsDashboard,
  canAccessCampaignsInsights,
  canAccessCampaignsRecommendations,
  canCreateCampaigns,
  canDeleteCampaign,
  canEditCampaign,
  canEndCampaign,
  canPublishCampaign,
  isCampaignAccessSettingsPending,
  isCampaignAutoSuggestionEnabled,
  isCampaignLandingPageInaccessible,
  isCampaignSashEnabled,
  isCampaignSearchEnabled,
  isCampaignsCoOrganizersEnabled,
  isCampaignsEnabled,
  isCampaignsExecutiveSponsorshipEnabled,
  isCampaignsHubEnabled,
} from '@ms/yammer-data/dist/domains/campaignRights/selectors';
import { Campaign } from '@ms/yammer-data/dist/state/types';

import { useSelector } from '../useSelector';
type UseIsCampaignsEnabled = () => ReturnType<typeof isCampaignsEnabled>;
export const useIsCampaignsEnabled: UseIsCampaignsEnabled = () => useSelector(isCampaignsEnabled);

type UseIsCampaignsHubEnabled = () => ReturnType<typeof isCampaignsHubEnabled>;
export const useIsCampaignsHubEnabled: UseIsCampaignsHubEnabled = () => useSelector(isCampaignsHubEnabled);

type UseIsCampaignsCoOrganizersEnabled = () => ReturnType<typeof isCampaignsCoOrganizersEnabled>;
export const useIsCampaignsCoOrganizersEnabled: UseIsCampaignsCoOrganizersEnabled = () =>
  useSelector(isCampaignsCoOrganizersEnabled);

type UseIsCampaignAutoSuggestionEnabled = () => ReturnType<typeof isCampaignAutoSuggestionEnabled>;
export const useIsCampaignAutoSuggestionEnabled: UseIsCampaignAutoSuggestionEnabled = () =>
  useSelector(isCampaignAutoSuggestionEnabled);

type UseIsCampaignsExecutiveSponsorshipEnabled = () => ReturnType<typeof isCampaignsExecutiveSponsorshipEnabled>;
export const useIsCampaignsExecutiveSponsorshipEnabled: UseIsCampaignsExecutiveSponsorshipEnabled = () =>
  useSelector(isCampaignsExecutiveSponsorshipEnabled);

type UseIsCampaignSashEnabled = () => ReturnType<typeof isCampaignSashEnabled>;
export const useIsCampaignSashEnabled: UseIsCampaignSashEnabled = () => useSelector(isCampaignSashEnabled);

type UseIsCampaignSearchEnabled = () => ReturnType<typeof isCampaignSearchEnabled>;
export const useIsCampaignSearchEnabled: UseIsCampaignSearchEnabled = () => useSelector(isCampaignSearchEnabled);

type UseIsCampaignAccessSettingsPending = () => ReturnType<typeof isCampaignAccessSettingsPending>;
export const useIsCampaignAccessSettingsPending: UseIsCampaignAccessSettingsPending = () =>
  useSelector(isCampaignAccessSettingsPending);

type UseCanAccessCampaignsDashboard = () => ReturnType<typeof canAccessCampaignsDashboard>;
export const useCanAccessCampaignsDashboard: UseCanAccessCampaignsDashboard = () =>
  useSelector(canAccessCampaignsDashboard);

type UseCanAccessCampaignsInsights = () => ReturnType<typeof canAccessCampaignsDashboard>;
export const useCanAccessCampaignsInsights: UseCanAccessCampaignsInsights = () =>
  useSelector(canAccessCampaignsInsights);

type UseCanAccessCampaignsRecommendations = () => ReturnType<typeof canAccessCampaignsRecommendations>;
export const useCanAccessCampaignsRecommendations: UseCanAccessCampaignsRecommendations = () =>
  useSelector(canAccessCampaignsRecommendations);

type UseCanCreateCampaigns = () => ReturnType<typeof canCreateCampaigns>;
export const useCanCreateCampaigns: UseCanCreateCampaigns = () => useSelector(canCreateCampaigns);

type UseIsCampaignLandingPageInaccessible = (
  campaignId: Campaign['id']
) => ReturnType<typeof isCampaignLandingPageInaccessible>;
export const useIsCampaignLandingPageInaccessible: UseIsCampaignLandingPageInaccessible = (campaignId) =>
  useSelector((state) => isCampaignLandingPageInaccessible(state, campaignId));

type UseCanEditCampaign = (campaignId: Campaign['id']) => ReturnType<typeof canEditCampaign>;
export const useCanEditCampaign: UseCanEditCampaign = (campaignId) =>
  useSelector((state) => canEditCampaign(state, campaignId));

type UseCanDeleteCampaign = (campaignId: Campaign['id']) => ReturnType<typeof canDeleteCampaign>;
export const useCanDeleteCampaign: UseCanDeleteCampaign = (campaignId) =>
  useSelector((state) => canDeleteCampaign(state, campaignId));

type UseCanPublishCampaign = (campaignId: Campaign['id']) => ReturnType<typeof canPublishCampaign>;
export const useCanPublishCampaign: UseCanPublishCampaign = (campaignId) =>
  useSelector((state) => canPublishCampaign(state, campaignId));

type UseCanEndCampaign = (campaignId: Campaign['id']) => ReturnType<typeof canEndCampaign>;
export const useCanEndCampaign: UseCanEndCampaign = (campaignId) =>
  useSelector((state) => canEndCampaign(state, campaignId));
